import { BUSINESS_CODE } from '@/constant/constant'

export const outboxBasic = {
  props: {
    businessCode: {
      type: String,
      default: BUSINESS_CODE.OFICIO
    }
  },
  computed: {
    isESign () {
      return this.businessCode === BUSINESS_CODE.ESIGN
    },
    title () {
      return this.businessCode === BUSINESS_CODE.ESIGN ? this.$t('TaskList.eSign.title') : this.$t('Outbox.SignOficio')
    }
  }
}
